export default {
  platformName: 'ServiceProvider',
  deviceConfig: {
    distribute: 'Send',
    distributeLog: 'Send Log',
    devOffLine: 'Device offline, unable to operate',
    ctrlGateWayPair1: 'Enable Pairing',
    ctrlGateWayPair0: 'Disable Pairing',
    noActionItems: 'No action items available',
    configDistribute: 'Config Send',
    issueValue: 'Send Item',
    issueCommand: 'Send Command',
    alarmThreshold: 'Alarm Threshold',
    trigger: 'Trigger Mode',
    mode: 'Mode',
    control: 'Control Mode',
    handMovement: 'Manual',
    automatic: 'Automatic',
    upperLimit: 'Upper Limit',
    lowerLimit: 'Lower Limit',
    cycle: 'Cycle',
    open: 'Open',
    close: 'Close',
    open1: 'Enable',
    delScheduledConfig: 'Delete this scheduled config',
    emergencyContact: 'Emergency Contact',
    familyContacts: 'Family Contact',
    timedReminder: 'Timed Reminder',
    reminderTime: 'Reminder Time',
    isDuplicate: 'Repeat',
    reminderCycle: 'Reminder Cycle',
    reminderCycleEmptyTip: 'Please select reminder cycle',
    reminderContent: 'Reminder Content',
    reminderContentEmptyTip: 'Please enter reminder content',
    uploadStatus: 'Send Status',
    Issueing: 'Sending',
    issuedSuccess: 'Send Success',
    issuedFail: 'Send Failed',
    issuedTimeout: 'Send Timeout',
    operationContext: 'Operation Content',
    operationTime: 'Operation Time',
    unlock: 'Unlock',
    lockMachine: 'Lock',
    grade: 'Level',
    // Fire Alarm Enable
    fireAlarmEnable0: 'Over Current',
    fireAlarmEnable1: 'Over Voltage',
    fireAlarmEnable2: 'Under Voltage',
    fireAlarmEnable3: 'Over Temperature',
    fireAlarmEnable4: 'Power Failure',
    fireAlarmEnable5: 'Arc',
    fireAlarmEnable6: 'Overload',
    fireAlarmEnable9: 'Phase Failure',
    fireAlarmEnable10: 'Three Phase Imbalance',
    fireAlarmEnable11: 'Neutral Missing',
    fireAlarmEnable12: 'Phase Error',
    fireAlarmEnable13: 'Neutral Live Reverse',
    fireAlarmEnable14: 'Over Temperature Warning',
    fireAlarmEnable15: 'Over Current Warning',
    fireAlarmEnable16: 'Over Voltage Warning',
    fireAlarmEnable17: 'Under Voltage Warning',
    fireAlarmEnable18: 'Overload Warning',
    fireAlarmEnable19: 'Leakage Warning',
    fireAlarmEnable21: 'Ignition',
    fireAlarmEnable22: 'Surge',
    fireAlarmEnable23: 'Ground Fault',
    fireAlarmEnable24: 'Over Power',
    fireAlarmEnable25: 'Over Electricity',
    fireAlarmEnable30: 'Leakage',
    onlineStatus: 'Online/Offline Status',
    // Trip Enable
    tripEnable0: 'Over Current',
    tripEnable2: 'Under Voltage',
    tripEnable4: 'Over Temperature',
    tripEnable5: 'Power Failure',
    tripEnable6: 'Arc',
    tripEnable9: 'Overload',
    tripEnable10: 'Phase Failure',
    tripEnable11: 'Three Phase Imbalance',
    tripEnable18: 'Neutral Live Reverse',
    tripEnable21: 'Ignition',
    tripEnable22: 'Ground Fault',
    tripEnable23: 'Auto Recovery',
    tripEnable24: 'Over Power',
    tripEnable25: 'Over Electricity',
    tripEnable30: 'Leakage',
    // Sound Config
    alarmTone: 'Alarm Tone',
    faultTone: 'Fault Tone',
    touchTone: 'Touch Tone',
    electricalFire: 'Electrical Fire',
    energy: 'Energy',
    powerQuality: 'Power Quality',
    // Output Linkage Mode
    mode1: 'Fire Alarm',
    mode2: 'Fire Fault',
    mode3: 'Smoke Alarm',
    mode4: 'Gas Alarm',
    mode6: 'Water Immersion Alarm',
    mode7: 'No Linkage',
    mode8: 'Sound & Light Linkage',
    mode9: 'Sound Linkage',
    mode10: 'Light Linkage',
    // Input Parameter Labels
    imputLable1: 'Pressure Alarm Upper Limit(MPa)',
    imputLable2: 'Pressure Alarm Lower Limit(MPa)',
    imputLable3: 'Water Pressure Fluctuation Threshold(MPa)',
    imputLable4: 'Impact Alarm Value',
    imputLable5: 'Tilt Angle Threshold(°)',
    imputLable6: 'Data Sampling Interval(s)',
    imputLable7: 'Data Report Interval(min)',
    imputLable8: 'Level Alarm Upper Limit(m)',
    imputLable9: 'Level Alarm Lower Limit(m)',
    imputLable10: 'Level Fluctuation Alarm(m)',
    imputLable11: 'Water Pressure Fluctuation Threshold(MPa)',
    // Upper/Lower Limit Tips
    upperLowerTip1: 'Pressure alarm upper limit must be greater than lower limit',
    upperLowerTip2: 'Level alarm upper limit must be greater than lower limit',
    // Lock Level Tips
    lockLevelTips1: 'Level 1: Prohibit local manual switch operation.',
    lockLevelTips2: 'Level 2: Prohibit local manual switch operation and parameter modification.',
    lockLevelTips3: 'Level 3: Prohibit local manual switch operation, parameter modification and mute.',
    // Warning Tips
    warningTip1: 'Please select lock level',
    warningTip2: 'Device lock cannot be sent with other config items',
    warningTip3: 'Please complete the form',
    warningTip4: 'Please complete the timed reminder info',
    warningTip5: 'Pressure parameters unchanged, please modify before sending',
    warningTip6: 'Data interval parameters unchanged, please modify before sending',
    warningTip7: 'Level parameters unchanged, please modify before sending',
    warningTip8: 'Hydraulic parameters unchanged, please modify before sending',
    warningTip9: '{name} cannot be empty',
    // WiFi Config
    wifiName: 'WiFi Name',
    wifiPsw: 'WiFi Password',
    wifichange: 'WiFi Switch',
    // Config File
    hostPwd: 'Host Password',
    pleasehostPwd: 'Please enter host password',
    pleasehostPwd4L: 'Please enter 4-8 digit password',
    profile: 'Config File',
    distributeProfile: 'Send Config File',
    pleaseCheckProfile: 'Please upload config file',
    // Migrated from other namespaces
    operate: 'Operate',
    yes: 'Yes',
    no: 'No',
    wrongNumType: 'Numbers Only',
    time: 'Time',
    config: 'Config',
    clickupload: 'Click to upload',
    selectAll: 'Select all',
    milicon: ':',
    pleasePsw: 'Please enter password',
    pswMax8: 'Password max 8 characters',
    name: 'Name',
    circuitNum: 'Loop Number',
    channelNum: 'Channel Number',
    detector: 'Detector',
    videoChannel: 'Video Channel',
    dev: 'Device',
    wifiOther: 'Other',
    clickRefresh: 'Click to Refresh',
    onlyCFG: 'Only files in .cfg format is supported',
    systemAddr: 'System Address/ Controller No.',
    channelCode: 'Channel No./Node No.',
    choosetime: 'Select Time',
    airSwitchOperation: 'Air Switch Operation',
    pleaseWiFiIP: 'Please enter WiFi password',
    pleaseSelectWiFi: 'Please select WiFi',
    queryFail: 'Query Failed!',
    sureIssue: 'Confirm sending {name}?',
    prompt: 'Tip',
    delTip: 'Are you sure you want to delete the selected data?',
    delTip1: 'This operation will clear all selected data. Do you want to proceed?'
  },
  // Air Switch related
  airSwitch: {
    view: 'View',
    selectAll: 'Select All',
    precisionMode: 'Precision Mode',
    energyConsumptionMode: 'Energy Consumption Mode',
    within: 'Within',
    model1: ', power consumption exceeds trigger alarm',
    model2: ', electricity consumption exceeds trigger alarm',
    powerConsumptionExceedsTriggerAlarm: 'Power consumption exceeds trigger alarm',
    riseWithinMinutesTriggerWarning: 'minutes rise...℃ trigger warning',
    restartTime: 'Restart Time',
    pleaseSelect: 'Please select',
    pleaseSelectTime: 'Please select time',
    second: 's',
    hour: 'h',
    never: 'Never',
    everyday: 'Everyday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    scheduledTaskSetting: 'Scheduled Task Setting',
    confirmBatchDelete: 'Are you sure you want to batch delete selected tasks?',
    confirmDelete: 'Are you sure you want to delete this task?',
    taskTip: 'Tip: Scheduled tasks support up to 20 entries',
    detector: 'Detector',
    detectorName: 'Detector Name',
    detectorModel: 'Detector Model',
    channelNumber: 'Channel Number',
    operationType: 'Operation Type',
    taskType: 'Task Type',
    executionTime: 'Execution Time',
    operation: 'Operation',
    openGate: 'Close Switch',
    closeGate: 'Open Switch',
    repeatTask: 'Repeat Task',
    singleTask: 'Single Task',
    addScheduledTask: 'Add Scheduled Task',
    pleaseSelectDetector: 'Please select detector',
    pleaseSelectOperation: 'Please select operation type',
    pleaseSelectTaskType: 'Please select task type',
    pleaseSelectExecutionTime: 'Please select execution time',
    pleaseSelectCycle: 'Please select cycle',
    operationFailed: 'Operation failed',
    // Alarm Enable
    overCurrentAlarmEnable: 'Over Current Alarm Enable',
    overVoltageAlarmEnable: 'Over Voltage Alarm Enable',
    underVoltageAlarmEnable: 'Under Voltage Alarm Enable',
    overTemperatureAlarmEnable: 'Over Temperature Alarm Enable',
    powerFailureAlarmEnable: 'Power Failure Alarm Enable',
    arcAlarmEnable: 'Arc Alarm Enable',
    overloadAlarmEnable: 'Overload Alarm Enable',
    leakageAlarmEnable: 'Leakage Alarm Enable',
    phaseFailureAlarmEnable: 'Phase Failure Alarm Enable',
    threePhaseImbalanceAlarmEnable: 'Three Phase Imbalance Alarm Enable',
    neutralMissingAlarmEnable: 'Neutral Missing Alarm Enable',
    phaseErrorAlarmEnable: 'Phase Error Alarm Enable',
    neutralLiveReverseAlarmEnable: 'Neutral Live Reverse Alarm Enable',
    temperatureWarningEnable: 'Temperature Warning Enable',
    overCurrentWarningEnable: 'Over Current Warning Enable',
    overVoltageWarningEnable: 'Over Voltage Warning Enable',
    underVoltageWarningEnable: 'Under Voltage Warning Enable',
    overloadWarningEnable: 'Overload Warning Enable',
    leakageWarningEnable: 'Leakage Warning Enable',
    // Action Enable
    overCurrentAlarmActionEnable: 'Over Current Action Enable',
    overVoltageAlarmActionEnable: 'Over Voltage Action Enable',
    underVoltageAlarmActionEnable: 'Under Voltage Action Enable',
    overTemperatureAlarmActionEnable: 'Over Temperature Action Enable',
    overloadAlarmActionEnable: 'Overload Action Enable',
    arcAlarmActionEnable: 'Arc Action Enable',
    powerFailureAlarmActionEnable: 'Power Failure Action Enable',
    leakageAlarmActionEnable: 'Leakage Action Enable',
    phaseFailureAlarmActionEnable: 'Phase Failure Action Enable',
    threePhaseImbalanceAlarmActionEnable: 'Three Phase Imbalance Action Enable',
    neutralLiveReverseActionEnable: 'Neutral Live Reverse Action Enable',
    groundFaultAlarmActionEnable: 'Ground Fault Action Enable',
    alarmAutoRecoveryActionEnable: 'Alarm Auto Recovery Action Enable'
  },
  // 视频监控
  videoModules: {
    pausePlayback: 'Pause',
    startPlaying: 'Play',
    cutPic: 'Snapshot',
    localRecording: 'Local Recording',
    closeIntercom: 'Disable Talk',
    openIntercom: 'Enable Talk',
    closeSound: 'Sound Off',
    openSound: 'Sound On',
    switchHD: 'Switch to HD',
    switchSD : 'Switch to SD',
    SD: 'SD',
    HD: 'HD',
    stop: 'Stop',
    switchDevRecording: 'Switch to Device Recording',
    switchCloudVideoRecording: 'Switch to Cloud Recording',
    cloud: 'Cloud',
    dev: 'Device',
    splitScreen: '{num} screens',
    closeAll: 'Close All',
    fullScreen: 'Full Screen',
    selectDate: 'Select Date',
    deviceOffLineNum: 'Device Offline',
    screenshotTip: 'Please play video before take screenshot',
    recordTip: 'Please broadcast live before record video',
    talkTip: 'Live before talkback',
    toggleMuteTip: 'Sound cannot be operated during talkback',
    noVideoStream: 'Stream not obtained',
    noPanTilt: 'No valid video is playing in the current window and you cannot operate the PTZ',
    PTZ: 'PTZ operation',
  },
  // HTTP Request related
  request: {
    errors: {
      badRequest: 'Bad Request',
      unauthorized: 'Unauthorized, please login again',
      forbidden: 'Access Denied',
      notFound: 'Request URL not found',
      serverError: 'Internal Server Error',
      badGateway: 'Bad Gateway',
      serviceUnavailable: 'Service Unavailable',
      gatewayTimeout: 'Gateway Timeout',
      networkError: 'Network error, please try again later',
      serviceException: 'Service Exception!',
      loginExpired: 'Login expired, please login again'
    },
    success: {
      operation: 'Operation successful!'
    }
  },
  common: {
    pleaseSelect: 'Please select ',
    pleaseInput: 'Please enter ',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Delete successful',
    back: 'Back',
    placeholder: 'Please enter keywords to search',
    pleaseSelectDeleteItem: 'Please select the data to delete',
    buttons: {
      search: 'Search',
      reset: 'Reset',
      add: 'Add',
      delete: 'Delete',
      view: 'View',
      edit: 'Edit',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      refresh: 'Refresh',
      export: 'Export'
    },
    tips: {
      prompt: 'Prompt',
      confirm: 'Confirm',
      cancel: 'Cancel',
      sureIssue: 'Confirm sending {name}?',
    },
    months: {
      1: 'January',
      2: 'February',
      3: 'March',
      4: 'April',
      5: 'May',
      6: 'June',
      7: 'July',
      8: 'August',
      9: 'September',
      10: 'October',
      11: 'November',
      12: 'December'
    },
    date: {
      Monday: ' Monday ',
      Tuesday: ' Tuesday ',
      Wednesday: ' Wednesday ',
      Thursday: ' Thursday ',
      Friday: ' Friday ',
      Saturday: ' Saturday ',
      Sunday: ' Sunday ',
      minute: 'Minute ',
      hour: 'Hour',
      day: 'Day',
      week: 'Week ',
      month: 'Month ',
      year: 'Year',
    }
  },
  menus: {
    '安装商': 'Installer',
    '设备运维': 'Dashboard',
    '站点管理': 'Site',
    '报警值守': 'Alarm Duty',
    '消息中心': 'Message',
    '客户管理': 'Customers',
    '我的单位': 'My Unit',
    '用户管理': 'User Manage',
    '角色管理': 'Role Manage',
    '站点列表': 'Site List',
    '站点详情': 'Site Detail',
    '设备详情': 'Device Detail',
    '管理员端': 'Administrator interface',
    '权限管理': 'Permission Management',
    'APP端': 'App Side',
    '首页': 'Home Page',
    '报警日志': 'Alarm Log',
    '故障日志': 'Fault Log',
    '发现': 'Detection',
    '设备管理': 'Device Manage',
    '视频监控': 'Video Surveillance',
    '我的': 'My',
    '消息': 'Message'
  },
  user: {
    pleaseInput: 'Please enter ',
    pleaseSelect: 'Please select ',
    account: 'Account',
    name: 'Name',
    role: 'Role',
    enabled: 'Is Enabled',
    enable: 'Enable',
    deactivate: 'Deactivate',
    email: 'Email',
    orgName: 'Department',
    phone: 'Phone',
    dept: 'Department',
    roleCfg: 'Role Config',
    dataPermCfg: 'Data Perm Config',
    candidate: 'Candidate List',
    selected: 'Selected List',
    selectAll: 'Select All',
    clear: 'Clear',
    add: 'Add User',
    edit: 'Edit User',
    batchDel: 'Batch Delete',
    back: 'Back',
    placeholder: 'Organization/Site/Administrative Division',
    searchHolder: 'Account/Name/Email',
    resetPsw: 'Reset password',
    setPsw: 'Set password',
    pswSendType1: 'Send a random password via email',
    pswSendType2: 'Custom password modification',
    resetPswSuccess: 'Reset password successfully',
    userNameTip1: "5-25 characters, supporting letters, numbers, and special characters ._{'@'} does not support pure numeric input",
    userNameTip2: 'Please do not include private information such as ID cards or bank cards. Once the settings are successfully completed, they cannot be modified',
    wrongUserName1: 'Please enter 5-25 characters',
    wrongUserName: 'Please enter the correct account number',
    modifyPwd: 'Change Password',
    modifyEmail: 'Change Email',
    cancel: 'Cancel Account',
    cancelS: 'Cancel Account successful',
    logout: 'Logout',
    cancelTip1: '1. Please exercise caution when canceling, as the operation is irreversible;',
    cancelTip2: '2. The unit does not owe any fees, and there are no stations or equipment under the unit.',
    sureLogoff: 'Delete account. Continue?'
  },
  role: {
    name: 'Role Name',
    createTime: 'Creation Time',
    remark: 'Remark',
    enterName: 'Please enter role name',
    add: 'Add Role',
    edit: 'Edit Role',
    inputRemark: 'Please enter remark',
    webPerm: 'WEB Perm',
    adminMenu: 'Admin Menu',
    appPerm: 'APP Perm',
    mobileMenu: 'Mobile Menu'
  },
  customer: {
    siteCount: 'number of sites',
    add: 'Add Customer',
    edit: 'Edit Customer',
    dialog: {
      fields: {
        account: 'Customer Account',
        name: 'Customer Name',
        phone: 'Customer Phone'
      },
      placeholders: {
        account: 'Please enter customer account',
        name: 'Please enter customer name',
        phone: 'Please enter customer phone'
      },
      messages: {
        addSuccess: 'Customer added successfully.',
        delTip: 'Customers with non-zero sites in the data you have selected will not be deleted!'
      }
    },
    validation: {
      countryCodeRequired: 'Please select country code',
      phoneRequired: 'Please enter phone number'
    }
  },
  tree: {
    rootNode: 'Root Node',
    actions: {
      expand: 'Expand',
      collapse: 'Collapse',
      search: 'Search',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel'
    },
    messages: {
      addSuccess: 'Added successfully',
      editSuccess: 'Edited successfully',
      deleteSuccess: 'Deleted successfully',
      deleteConfirm: 'Are you sure you want to delete "{name}"?',
      deleteTitle: 'Warning',
    }
  },
  org: {
    title: 'Organization Tree',
    title1: 'Department Tree',
    placeholder: {
      search: 'Search by organization name',
      orgName: 'Enter organization name'
    },
    dialog: {
      addTitle: 'Add Organization',
      editTitle: 'Edit Organization',
      parentOrg: 'Parent Organization',
      orgName: 'Organization Name'
    },
    messages: {
      validation: {
        orgNameRequired: 'Organization name is required'
      }
    }
  },
  region: {
    title: 'Region Tree',
    placeholder: {
      search: 'Search Region',
      nodeName: 'Enter node name',
      leader: 'Select leader'
    },
    dialog: {
      addTitle: 'New Region',
      editTitle: 'Edit Region',
      nodeType: 'Node Type',
      parentNode: 'Parent Node',
      nodeName: 'Node Name',
      leader: 'Leader'
    },
    types: {
      group: 'Group (Logical)',
      region: 'Region (Physical)'
    },
    messages: {
      validation: {
        nameRequired: 'Node name is required',
        leaderRequired: 'Leader is required'
      }
    },
    popover: {
      regionName: 'Region Name',
      managerName: 'Manager Name',
      managerEmail: 'Manager Email'
    }
  },
  device: {
    avg: 'Avg',
    eventStart: 'Event Start',
    eventEnd: 'Event End',
    card: {
      type: 'Type',
      sn: 'S/N',
      model: 'Model',
      region: 'Region',

      status: {
        online: 'Online',
        offline: 'Offline',
        alarm: 'Alarm',
        fault: 'Fault',
        inactive: 'Inactive',
        normal: 'Normal'
      },

      remaining: 'Remaining',
      days: ' days',
      tooltip: {
        life: 'Remaining Life',
        replaceDate: 'Replace Date',
        firstOnline: 'First Online'
      },

      actions: {
        edit: 'Edit Device',
        view: 'View Video',
        migration: 'Device Migration',
        delete: 'Delete Device'
      }
    },
    list: {
      bulkAction: 'Batch Action',
    },
    actions: {
      batchDelete: 'Batch Delete',
      deviceMigrate: 'Device Migration',
      deviceAdd: 'Device Add',
      confirm: 'Confirm',
      cancel: 'Cancel'
    },
    messages: {
      warning: 'Warning',
      batchDeleteConfirm: 'Are you sure you want to delete the selected devices? This cannot be undone.',
      addSuccess: 'Device added successfully'
    },
    // Device Add Drawer
    drawer: {
      title: {
        add: 'Add Device'
      }
    },
    // Device Form
    form: {
      deviceName: 'Device Name',
      region: 'Region',
      deviceModel: 'Device Model',
      connectWay: 'Connection Type',
      serialNumber: 'Serial Number',
      deviceCode: 'Device Code',
      imeiMac: 'IMEI/MAC',
      mapAddress: 'Part Address Mapping',
      username: 'Username',
      password: 'Password',
      superiorLimit: 'Upper Limit',
      lowerLimit: 'Lower Limit',
      randomGet: 'Random Generate',
      uniqueCode: 'IMEI/MAC',
      devUsername: 'Username',
      devPassword: 'Password'
    },
    // Form Validation
    validation: {
      required: 'Please enter {field}',
      selectRequired: 'Please select {field}',
      formatError: 'Invalid {field} format',
      lowerThanUpper: 'Lower limit must be less than upper limit',
      pleaseInputDeviceName: 'Please enter device name',
      pleaseSelectRegion: 'Please select region',
      pleaseSelectDeviceModel: 'Please select device model',
      pleaseSelectConnectWay: 'Please select connection type',
      pleaseInputSerialNumber: 'Please enter serial number',
      pleaseInputDeviceCode: 'Please enter device code',
      pleaseInputImeiMac: 'Please enter IMEI/MAC',
      pleaseSelectMapAddress: 'Please select part address mapping',
      pleaseInputUsername: 'Please enter username',
      pleaseInputPassword: 'Please enter password',
      pleaseInputSuperiorLimit: 'Please enter upper limit',
      pleaseInputLowerLimit: 'Please enter lower limit',
      pleaseInputIMEI: 'Please enter 15-digit IMEI',
      pleaseInputCode: 'Please enter device code',
      pleaseInputUniqueCode: 'Please enter IMEI/MAC'
    },
    // Tips
    tips: {
      imei: 'IMEI: Device IMEI number, 15 digits',
      mac: 'MAC: Device MAC address, 12 hexadecimal characters',
      code: 'Device Code: Unique device identifier',
      passwordTip1: '1. Please enter the 8-digit security code on the label or QR code at the bottom of the device if you have not changed the device password.',
      passwordTip2: '2. Please enter your new device password if you have changed the device password.',
      passwordTip3: '3. Make the password field null if you have not changed the device password and the label or QR code at the bottom has no 8-digit security code.'
    },
    // Buttons
    buttons: {
      submit: 'Confirm',
      submitAndAddDetector: 'Save & Add Detector',
      randomGet: 'Random Generate'
    },
    // 新增的筛选器相关词条
    filter: {
      typeLabel: 'Device Type',
      unlimited: 'All',
      placeholder: 'Search Device Type',
      selected: 'Selected',
      clear: 'Clear',
      statusLabel: 'Device Status',
      categories: {
        alarm: 'Alarm Status',
        online: 'Online Status',
        fault: 'Fault Status'
      },
      options: {
        alarm: {
          0: 'Alarm',
          1: 'Normal'
        },
        online: {
          0: 'Offline',
          1: 'Online',
          2: 'Inactive',
        },
        fault: {
          0: 'Fault',
          1: 'Normal'
        }
      }
    },
  },

  // 设备详情
  deviceDetail: {
    tabs: {
      detectorInfo: 'Detector Information',
      videoInfo: 'Video Channel Information',
      deviceBasicInfo: 'Device Basic Information',
      zone: 'Zone',
      detector: 'Detector',
      video: 'Channel',
      alarmLog: 'Alarm Log',
      faultLog: 'Fault Log',
      onlineOfflineRecord: 'Online/Offline Record',
      otherMessageRecord: 'Other Message Record',
      deviceMonitoringValue: 'Monitoring Value',
      deviceConfiguration: 'Configuration'
    },
    monitorValue: {
      unit: 'unit',
      report: 'Report',
      monitorTrend: {
        allData: 'All Data',
        history: 'History',
        max: 'Maximum Value',
        min: 'Minimum Value',
        alarmUpper: 'Alarm Upper Limit',
        alarmLower: 'Alarm Lower Limit',
        propertyValue: 'Value',
        alarmLogStartTime: 'Reception Time',
      },
      wifi: {
        normal: 'Normal',
        abnormal: 'Abnormal ',
        noNetwork: 'Network Error ',
        relativelyPoor: 'Relatively Poor ',
        sameAs: 'Average ',
        preferably: 'Fair ',
        veryPoor: 'Very Poor ',
        excellent: 'Excellent',
        tall: 'High',
        low: 'Low',
        fault: 'Fault',
        weak: 'Weak ',
        centre: 'Medium',
        strong: 'Strong ',
        other: ' Other:',
        good: 'Good',
        poor: 'Poor',
        title1: 'Wi-Fi signal strength',
        title2: 'Signal strength ',
        title3: '1. Make judgments based on CSQ',
        title4: '2. Make judgments based on RSRP and SNR',
        title5: '2.1. Firstly, make judgments according to RSRP',
        title6: '2.2. Then, take corrective measures according to the SNR value',
        tips1: 'RSRP reduces by one level if SNR is poor.',
        tips2: 'Medium/weak signal reduces by one level if SNR is medium.',
        tips3: 'Signal level is not affected if SNR is good.'
      },
      updateTime: 'Update time',
    },
    alarmLog: {
      batchAlarmTItle: 'Batch Process Alarms',
      refresh: 'Refresh',
      columns: {
        platRecepTime: 'Reception Time',
        policeType: 'Alarm Type',
        devName: 'Device Name',
        deviceType: 'Device Type',
        confirmStatus: 'Confirmation Status',
        confirmUserName: 'Confirmed By',
        confirmResult: 'Confirmation Result',
        confirmTime: 'Confirmation Time',
        eventStatus: 'Clear alarm status',
        alarmLogEndTime: 'Clear time',
        alarmLogId: 'Alarm ID',
      },
      batchDialog: {
        memo: 'Description',
        describePlaceholder: 'Please enter description',
        allFalseAlarm: 'All False Alarms',
        allTest: 'All Tests',
        batchAlarmInfo: 'Batch process alarms. No alarm notifications will be sent.',
      },
      seachHolder: {
        nameHolder: 'device/detector name',
        idHolder: 'event ID',
        startTime: 'Start time',
        endTime: 'End time'
      },
      filters: {
        falseAlarm: 'False Alarm',
        test: 'Test',
        fireAlarm: 'Fire alarm',
        commonAlarm: 'Alarm',
        warning: 'General Alarm',
        alarm: 'Major Alarm',
        fault: 'Fault',
        info: 'Info',
        firedAlarm: 'Cleared',
        unclearAlarm: 'Not Clear',
        confirmed: 'Confirmed',
        unconfirmed: 'Unconfirmed',
        confirming: 'Confirming',
        processed: ' Processed ',
        unProcessed: ' Unprocessed ',
      },
      confirmResult: {
        0: 'False Alarm',
        1: 'Test',
      },
      confirmStatus: {
        0: 'Unconfirmed',
        1: 'Confirmed',
        2: 'Confirming',
      },
      oprate: {
        manualTurnAlarm: 'Manually Clear Alarms',
        detail: 'View',
        handle: 'Process',
        clearAlarmTip: 'Manual Cancel Alarm only changes the alarm status of the Device on the platform. Please use it with caution!',
        prompt: 'Tip',
      },
      dialog: {
        alarmDetail: 'Alarm Details',
        alarmProcess: 'Alarm Handling',
        alarmInfo: 'Alarm Information',
        alarmId: 'Alarm Log ID',
        alarmStartTime: 'Platform Receipt Time',
        devOriginRecordTime: 'Device Original Record Time',
        eventStatus: 'Alarm Clear Status',
        alarmEventStatus: {
          0: 'Cleared',
          1: 'Not Clear',
        },
        regionPerson: 'Regional Head',
        devInfo: 'Device Information',
        monitorValue: 'Monitoring Value',
        flowEvent: 'Event Process',
        hanndleMethod: ' Processing Method ',
        describePlaceholder: 'Please enter description',
        alarmReason: 'Alarm Reason',
        setCenterPoint: 'Setting Center',
        amplify: 'Zoom In',
        reduce: 'Zoom Out',
        fullScreen: 'Full Screen',
        exitFullScreen: 'Exit Full-screen',
        position: ' Location Info ',
        plane: 'Floor Plan',
        video: 'Live Video',
        faultPic: 'Fault Picture',
        playbackVideo: 'Playback Video',
        alarmPic: 'Alarm Picture',
      }
    },
    faultLog: {
      columns: {
        faultType: 'Fault Type',
        devRepairStatus: 'Device Repair Status',
        repairTime: 'Fix Time',
        dealState: ' Processing Status ',
        hanndleTime: 'Processing Time',
        hanndler: ' Processor ',
      },
      dialog: {
        alarmDetail: 'Fault Details',
        alarmProcess: 'Fault Handling',
        faultInfo: 'Fault Info',
        faultLogID: 'Fault Log ID',
        devRepairStatus: 'Device Repair Status',
        hanndleResults: 'Processing Result',
        faultEventStatus: {
          0: 'Fixed',
          1: 'Not fixed',
        },
        zone: 'Zone',
        zoneNumber: 'Zone {num}',
        deviceName: 'Device Name',
        deviceType: 'Device Type',
        deviceSn: 'IMEI/MAC/SN',
        deviceId: 'Device SN',
        detailAddr: 'Detailed Address',
        channelName: 'Video channel name',
        detectorName: 'Detector Name ',
        circuitNum: ' Loop Number ',
        systemAddr: ' System Address ',
        controllerNum: ' Controller No. ',
        nodeNum: ' Node No. ',
        channelNum: ' Channel Number ',
      }
    },
    orderIssueSuc: 'Send successful, waiting for device response...',
  },

  deviceBasicInfo: {
    devName: 'Device Name',
    companyName: 'Organizational Unit',
    storeName: 'Site Name',
    deviceType: 'Device Type',
    deviceModel: 'Device Model',
    deviceId: 'Device SN',
    longitude: 'Longitude',
    latitude: 'Latitude',
    onlineState: 'Online Status',
    deviceStatus: 'Fault Status',
    monitoringStatus: 'Alarm Status',
    connectWay: 'Access Method',
    deviceSn: 'IMEI/MAC/SN',
    partsMappingAddr: 'Part address mapping',
    CODE: 'Device ID',
    devLoginName: 'Login Name',
    devLoginPassword: 'Login Password',
    devInstallTime: 'Device Installation Time',
    lifeTime: 'Life Time',
    remainingLifeTime: 'Remaining Life Time',
    changeDate: 'Change Date',
    priorityValue: 'Priority Value',
    deviceOperation: 'Device Operation',
    deviceInstallPic: 'Device Installation Pictures',
    isMergeAlarms: ' Combine alarms or not: ',
    mergeAlarmsTime: ' Combined alarm time: ',
  },

  // 防区
  zone: {
    zone: 'Zone',
    shieldStatus: 'Shield Status',
    shield: 'Shield',
    shieldDisabled: 'Disabled',
    shieldActive: 'Active',
    videoLinkage: 'Video Linkage',
    alarmStatus: 'Alarm Status',
    faultStatus: 'Fault Status',
    normal: 'Normal',
    alarm: 'Alarm',
    fault: 'Fault'
  },

  detectorVideo: {
    detectorName: 'Detector Name',
    storeName: 'Belonging Area',
    deviceName: 'Belonging Device',
    deviceId: 'Device Serial Number',
    detectorType: 'Detector Type',
    detectorStatus: 'Fault Status',
    productModel: 'Detector Model',
    channelName: 'Video Channel Name',
    channelType: 'Channel Type',
    channelId: 'Channel Number',
    onlineStatus: 'Online Status',
    devChannelStatus: 'Fault Status',
    inputDetectorName: 'Please enter detector name',
    controllerNumber: 'Controller Number',
    systemAddress: 'System Address',
    loopNumber: 'Loop Number',
    nodeNumber: 'Node Number',
    channelNumber: 'Channel Number',
    zone: 'Defense Zone',
    mustBeNumber: 'Must Be Number',
    detectorNameAndModel: 'Detector Name / Model',
    detectorSn: 'Detector SN',
    gatewayPairingProcess: 'Gateway Pairing Process',
    getDetectorList: 'Get Detector List',
    statusEnum: {
      0: 'Fault',
      1: 'Normal',
    },
    onlineEnum: {
      0: 'Offline',
      1: 'Online',
      2: 'Inactive',
    },
    monitorEnum: {
      0: 'Alarm',
      1: 'Normal',
    },
    view: {
      detectorInfo: 'Detector Information',
      videoInfo: 'Video Channel Information',
      devChannelStatus: 'Fault Status',
      channelAlarmStatus: 'Alarm Status',
      productModel: 'Detector Model',
      deviceImei: 'Device Code',
      alarmSub: 'Alarm Subscription',
    },
    gatewayPair: {
      gatewayProcess: 'Gateway pair process',
      gatewayTab1: 'Gateway Lite',
      gatewayTab2: 'Gateway Pro',
      gatewaytitle1: '1. Power-on of gateway',
      gatewaytitle2: '2. Gateway enters pairing mode',
      gatewaytitle3: '3. Power-on of detector',
      gatewaytitle4: '4. Detector enters pairing mode',
      gatewaytitle5: '5. Gateways and detectors interconnection',
      gatewaydes1_1: 'Place the device in the center of your home and keep the device powered on during the setup process. Click Next to add the device.',
      gatewaydes1_2: 'Click the gateway pairing button three times. The green LED will flash, and the gateway will enter pairing mode.',
      gatewaydes1_4: 'Click the detector button three times. When the green LED flashes, the detector will enter pairing mode.',
      gatewaydes1_5: 'Wait for a period of time, gateway and detector interconnecting.',
      gatewaydes2_2: 'Click the gateway pairing button three times. The green LED will flash, and the gateway will enter pairing mode. Alternatively, enter the device configuration interface and send the "Enter pairing mode" command for automatic pairing.'
    },
  },


  // 在线/离线记录
  onlineOfflineRecord: {
    // 在离线时间、设备名称、状态、 在线、离线
    columns: {
      onlineOfflineTime: 'Online/Offline Time',
      deviceName: 'Device Name',
      status: 'Status',
      online: 'Online',
      offline: 'Offline'
    }
  },

  // 其他消息记录
  otherMessageRecord: {
    // 平台接收时间、设备原始记录时间、设备名称、消息类型、状态
    columns: {
      platformReceiveTime: 'Platform Receive Time',
      deviceOriginalRecordTime: 'Device Original Record Time',
      deviceName: 'Device Name',
      detectorName: 'Detector Name',
      messageType: 'Message Type',
      status: 'Status'
    }
  },

  site: {
    // Search & Buttons
    placeholder: {
      searchSite: 'Search Site'
    },
    // Site Delivery Drawer
    delivery: {
      title: 'Site Delivery',
      basicInfo: 'Basic Information',
      hostingInfo: 'Entrusting Information',
      fields: {
        customer: 'Delivery Customer',
        siteHosting: 'Site Entrusting',
        hostingPeriod: 'Entrusting Period',
        applyPermission: 'Apply Permission:',
        deviceManagement: 'Device Management',
        remoteControl: 'Remote Control',
        audioVideo: 'Audio & Video'
      },
      placeholders: {
        customer: 'Please select customer',
        hostingPeriod: 'Please select entrusting period',
        duration: 'Please select duration'
      },
      options: {
        on: 'On',
        off: 'Off'
      },
      periods: {
        days7: '7 Days',
        days30: '30 Days',
        days90: '90 Days',
        days180: '180 Days',
        days365: '365 Days',
        custom: 'Custom'
      },
      durations: {
        hour1: '1 Hour',
        hour2: '2 Hours',
        hour4: '4 Hours',
        hour8: '8 Hours',
        fullPeriod: 'Full Entrusting Period'
      },
      units: {
        days: 'Days'
      },
      tips: {
        defaultOn: 'Default On',
        hostingPeriod: 'The actual effective period is subject to the time when the customer approves',
        defaultSelected: 'Default selected, 1 hour',
        deviceManagement: 'Add, modify, delete devices and other operations within the site',
        remoteControl: 'Send control commands, parameter configuration, remote upgrade and other operations to interact with devices through the platform',
        audioVideo: 'Video Streaming, Playback, Two-Way Audio, PTZ Control, Fisheye, Audio Tracks, and Other Operations'
      },
      messages: {
        submitSuccess: 'Site delivery successful',
        durationExceedRemaining: 'The permission duration of {permissions} has exceeded the remaining entrusting time, please reselect'
      }
    },

    // Status Code
    status: {
      pendingDelivery: 'Pending Delivery',
      pendingManaged: 'Not Entrusted',
      pendingAcceptance: 'Pending Acceptance',
      pendingConfirmation: 'Waiting for Confirmation',
      managed: 'Entrusted',
      managedExpired: 'Entrusting Expired',
      delivered: 'Delivered'
    },

    // Table Columns
    columns: {
      siteName: 'Site Name',
      siteStatus: 'Status',
      uprn: 'UPRN',
      customerName: 'Customer',
      deviceCount: 'Device Qty',
      customerEmail: 'Email',
      customerPhone: 'Phone',
      adminArea: 'Administrative Area',
      address: 'Address',
      remark: 'Remark',
      action: 'Action',
      columnSettings: 'Column Settings'
    },

    // Messages
    messages: {
      deleteConfirm: 'Are you sure you want to delete this data?',
      unsavedExit: 'Unsaved changes detected. Are you sure you want to exit?',
      exitTitle: 'Exit Confirmation',
      overwriteConfirm: 'Are you sure you want to save and overwrite site data?',
      saveTitle: 'Save Confirmation'
    },

    // Header & Alerts
    permissionsExpiring: "The 'Audio/Video' permission you applied for is about to expire",
    applyImmediately: 'Apply Now',
    managed: 'Entrusted',
    siteDelivery: 'Site Delivery',
    siteAcceptance: 'Site Acceptance',
    entrustedApproval: 'Entrusted Approval',

    // Site Acceptance Dialog
    acceptance: {
      title: 'Site Acceptance',
      fields: {
        result: 'Acceptance Result',
        orgName: 'Organization',
        rejectReason: 'Reject Reason'
      },
      options: {
        pass: 'Agree',
        reject: 'Reject'
      },
      placeholders: {
        orgName: 'Please select organization',
        result: 'Please select acceptance result',
        rejectReason: 'Please enter reject reason'
      },
      messages: {
        submitSuccess: 'Acceptance submitted successfully'
      }
    },
    applyAuth: 'Apply Permission',
    cancelManaged: 'Cancel Management',
    renewManaged: 'Renew Management',
    siteHosting: 'Site Entrusting',

    // Site Hosting
    hosting: {
      fields: {
        installer: 'Installer'
      },
      placeholders: {
        installer: 'Please select installer'
      }
    },

    // Cancel Hosting
    cancelHosting: {
      title: 'Cancel Entrusting',
      confirmText: 'Are you sure you want to cancel the hosting service?',
      placeholder: 'To improve our service, please fill in the specific reason for the customer to cancel the hosting or customer suggestions',
      reasonRequired: 'Reason is required',
      confirmBtn: 'Cancel Entrusting',
      messages: {
        success: 'Entrusting cancelled successfully'
      }
    },

    // Tabs
    tabs: {
      all: 'All',
      managed: 'Entrusted',
      todo: 'To Do',
      history: 'History',
      deviceMgmt: 'Device Management',
      siteDetail: 'Site Details',
      eventLogs: 'Event Logs',
      operationLogs: 'Operation Logs'
    },

    // Detail Sections Headers
    basicInfo: 'Basic Information',
    customerInfo: 'Customer Information',
    installerInfo: 'Service Provider Information',
    installer: 'Installer',
    managedInfo: 'Management Information',

    // Basic Information Fields
    uprn: 'UPRN',
    timezone: 'Timezone',
    adminArea: 'Administrative Area',
    detailedAddress: 'Address',
    remarks: 'Remarks',

    // Customer Information Fields
    customerName: 'Name',
    customerEmail: 'Email',
    customerPhone: 'Phone',

    // Installer Table Headers
    installerName: 'Name',
    installerPhone: 'Phone',
    installerEmail: 'Email',

    // Management Information Fields
    managedPeriod: 'Entrusting Period',
    deviceMgmtDuration: 'Device Mgmt',
    remoteControl: 'Remote Control',
    audioVideo: 'Audio & Video',
    audioVideoPermissionsOver: 'Audio & Video Permissions Over',
    expired: 'Expired',

    // Status & Units
    remaining: 'Remaining: ',
    year: 'y ',
    month: 'm ',
    day: 'd ',
    hour: 'h ',
    minute: 'min ',
    second: 's',
    notApplied: 'Not Applied',

    // Site Editor
    editor: {
      fields: {
        siteName: 'Site Name',
        timeZone: 'Timezone',
        uprn: 'UPRN',
        orgName: 'Organization',
        customerAccount: 'Customer Account',
        phone: 'Phone',
        region: 'Region',
        address: 'Address',
        remark: 'Remarks'
      },
      placeholders: {
        siteName: 'Please enter site name',
        timeZone: 'Please select timezone',
        uprn: 'Please enter UPRN',
        phone: 'Please enter phone number',
        select: 'Please select',
        region: 'Please select region',
        address: 'Please enter address',
        remark: 'Please enter remarks'
      },
      buttons: {
        addCustomer: 'Add Customer'
      },
      messages: {
        timeZoneWarning: 'Once selected, it cannot be modified. Please proceed with caution!',
        validationFailed: 'Validation failed',
        uprnLengthError: 'UPRN must be 8 characters'
      }
    }
  },
  loginInfo: {
    login: 'Login',
    pleaseInput: 'Please enter ',
    pleaseSelect: 'Please select ',
    welcome: 'Welcome to Wisualarm',
    loginTips: 'Sign In to your account',
    email: 'Email',
    newEmail: 'New email',
    editEmail: 'Modify email',
    noAccount: 'No account?',
    registerNow: 'Register now',
    existingAccount: 'Already have an account?',
    loginNow: 'Log in immediately',
    createAccount: 'Create an account',
    basicInfo: 'Basic Information',
    setPsd: 'Set Password',
    resetPsd: 'Reset Password',
    IDCheck: 'Identity Verification',
    contry: 'Country/Region',
    contryTip: 'To ensure a great experience, please select your country/region accurately. Selection is final.',
    imgCode: 'Graphic Verification Code',
    dynamicCode: 'Dynamic Verification Code',
    GetDynamicCode: 'Get verification code',
    reSend: 'Resend',
    next: 'Next step',
    skip: 'Skip',
    complete: 'Completed',
    password: 'Password',
    oldPsd: 'Old password',
    confirmPsw: 'Confirm Password',
    wrongPsw: 'The password length must be between 8 and 32 characters.',
    wrongPswTips: 'Your password must meet 4 of the following requirements:',
    lowercase: 'Contain at least one lowercase letter (a-z)',
    uppercase: 'Contain at least one uppercase letter (A-Z)',
    number: 'Contain at least one number (0-9)',
    special: 'Contain at least one allowed special character',
    specialTip: 'Special characters include:',
    diffPsw: 'The passwords entered twice do not match!',
    forgetPsw: 'Forgot your password?',
    forgetPswTitle: 'Forgot password',
    rememberPsw: 'Remember password',
    noEmailTips: 'Please enter your email address and the graphical verification code first.',
    termsAndPolicies: 'I have read and agree to the [click:1] Terms of Service [/click] and [click:2] Privacy Policy [/click].',
    pleaseCheckPolicy: 'Read and accept the Terms & Conditions and Privacy Policy',
    dahuaGF: 'Copyright © 2021 Zhejiang Wisualarm Technology Co., Ltd.',
    zheNum1: "{'@'}2021 Wisualarm Technology. Zhejiang ICP Archive No. 2021005411 ",
    zheNum: 'Zhejiang ICP07004180',
    footerT: 'Zhejiang Network Security Record',
    footerT1: 'NO. 33010802003424 ',
    footerT2: 'NO. 33010802005650 ',
    contactUs: 'Contact Us',
    serviceHotline: 'Service Hotline',
    downloadQRCode:'Scan the QR code to download',
    emailCodesendS: 'The verification code has been sent to your email. Please check your inbox.',
    registerSuccess: 'Registration successful!',
    pswEditSuccess: 'Password modification successful!',
    loginSuccess: 'Login successful!',
    noUser: 'No user found.',
    wrongEmail: 'Enter a valid email address.',
  },
  msgCenter: {
    pending: 'Pending',
    processed: 'Processed',
    basicInfo: 'Basic Information',
    installerName: 'Customer Name',
    siteName: 'Site Name',
    installerEmail: 'Customer Email',
    installerPhone: 'Customer Phone',
    occurTime: 'Occurrence Time',
    deviceList: 'Device List',
    deviceName: 'Device Name',
    serialNumber: 'Serial Number',
    onlineStatus: 'Online Status',
    faultStatus: 'Fault Status',
    online: 'Online',
    offline: 'Offline',
    unactivated: 'Unactivated',
    fault: 'Fault',
    normal: 'Normal',
    agree: 'Agree',
    reject: 'Reject',
    approved: 'Approved',
    expired: 'Expired',
    rejected: 'Rejected',
    inspect: 'Go for acceptance',
    toDoItems: 'To-Do',
    completedItem: 'Completed',
    viewall: 'View all',
    notice: 'Notice',
    msgNotice: 'Message Notice',
    noDataTip: 'Please select the to-do list or message notification you want to view first',
    prompt: 'Prompt',
    rejectTip: 'Are you sure you want to reject this hosting application?',
    org: 'Org',
    rejectReason: 'Reject Reason',
    inputReason: 'Please enter the rejection reason',
    selectOrg: 'Please select an organization',
    notShowAgain: 'Don\'t Show Again',
    viewNow: 'View Now',
    canceReason: 'Reason for cancellation',
    titleType: {
      site_delivery: 'Site Delivery',
      delivery_and_apply_hosting: 'Deliver Site and Apply for Hosting',
      site_hosting: 'Site Hosting',
      hosting_renewal: 'Hosting Renewal',
      apply_device_permission: 'Apply for Device Permission',
      site_acceptance: 'Site Acceptance',
      apply_hosting: 'Apply for Hosting',
      hosting_expiring: 'Hosting Expiring Soon',
      hosting_expired: 'The hosting has expired',
      cancel_hosting: 'Cancel Hosting'
    },
    summary: {
      template: 'You have received a {type} message. Please process it promptly. If not handled within 3 days, the application will automatically expire.',
      10: 'The site you delivered has passed acceptance, please pay attention in time.',
      11: 'The site you delivered has been rejected in acceptance, please pay attention in time.',
      12: 'The {companyName} has approved your Entrusting request, please pay attention in time.',
      13: 'The {companyName} has rejected your Entrusting request, please pay attention in time.',
      14: 'The {companyName} has approved your Entrusting renewal request, please pay attention in time.',
      15: 'The {companyName} has rejected your Entrusting renewal request, please pay attention in time.',
      16: 'The Entrusting for {siteName} is expiring soon. Please take action promptly.',
      17: 'The Entrusting for {siteName} has expired. Please take action promptly.',
      18: '{companyName} has approved your device permission request. Please stay updated promptly.',
      19: '{companyName} has rejected your device permission request. Please pay attention promptly.',
      20: 'You have received a cancellation notice for a hosted site. Please review promptly.'
    },
    hosting: {
      device_management: 'Device Management',
      remote_control: 'Remote Control',
      audio_video: 'Audio & Video',
      FULL_PERIOD: 'Full-cycle Entrusting',
      HOST_PERIOD: 'Entrusting Period',
      HOST_Renewal: 'Renewal of Custody',
      title: 'Entrusting Information'
    }
  },
  // 设备运维
  deviceOps: {
    dashboard: "Dashboard",
    siteStatus: "Site Status",
    undelivered: "Undelivered",
    delivered: "Delivered",
    siteOrganization: "Site & Organization",
    onlineOfflineStatistics: "Device Online/Offline Statistics",
    deviceTotal: "Device Total",
    offline: "Offline",
    online: "Online",
    total: "Total",
    rate: "Rate",
    unactivated: "Unactivated",
    faultStatusStatistics: "Fault Status Statistics",
    firefightingEquipment: "Firefighting Equipment",
    detector: "Detector",
    videoEquipment: "Video Equipment",
    videoChannel: "Video Channel",
    normal: "Normal",
    fault: "Fault",
    normalRate: "Normal Rate",
    faultTypeTop5: "Fault Type TOP5",
    dataSourcedFromFaultLog: "The data is sourced from the fault log",
    "24VOutputOpenCircuit": "24V Output Open Circuit",
    registeredDeviceDisconnected: "Registered Device Disconnected",
    eachElectricalConnectionFault: "Each Electrical Connection Fault",
    mainElectricalConnectionFault: "Main Electrical Connection Fault",
    detentionAlarm: "Detention Alarm",
    todoItems: "To-Do Items",
    processNow: "Process Now",
    siteOverview: "Site Overview",
    undeliveredItems: "Undelivered",
    unaccepted: "Unaccepted",
    unconfirmed: "Unconfirmed",
    managed: "Managed",
    managedExpired: "Managed Expired",
    deviceOverview: "Device Overview",
    deviceStatusTrendChart: "Device Status Trend Chart",
    deviceOfflineRate: "Device Offline Rate",
    deviceFaultRate: "Device Fault Rate",
    detectorFaultRate: "Detector Fault Rate",
    videoChannelFaultRate: "Video Channel Fault Rate",
    last7days: "Last 7 days",
    last30days: "Last 30 days",
    faultSystemsDistribution:"Fault Systems Distribution",
    smartWater:"Smart Water",
    smartElectricity:"Smart Electricity",
    traditionalFirefighting:"Traditional Firefighting",
    videoSurveillance:"Video Surveillance",
    industrialFirefighting:"Industrial Firefighting",
    smartChargingPile:"Smart Charging Pile",
    intelligentEarlyWarning:"Intelligent Early Warning",
    more: 'More',
    placeholder: {
      select: 'Please select',
      search: 'Please enter keywords', // 请输入关键词
    }
  },
  // Event Logs
  eventLogs: {
    menu: {
      fault: 'Fault Logs',
      alarm: 'Alarm Logs',
      onlineOffline: 'Online/Offline Logs',
      other: 'Other Messages'
    },
    placeholder: {
      search: 'Please enter the device name/detector name/serial number',
      searchDeviceId: 'Please enter device ID'
    },
    columns: {
      deviceName: 'Device Name',
      detectorName: 'Detector Name',
      serialNumber: 'Serial Number',
      deviceType: 'Device Type',
      faultType: 'Fault Type',
      alarmType: 'Alarm Type',
      infoType: 'Info Type',
      eventType: 'Event Type',
      status: 'Status',
      platformReceiveTime: 'Platform Receive Time',
      repairStatus: 'Repair Status',
      faultEventStatus: {
        0: 'Fixed',
        1: 'Unfixed',
      },
      alarmEventStatus: {
        0: 'Cleared',
        1: 'Uncleared',
      },
      repairTime: 'Repair Time',
      clearStatus: 'Clear Status',
      clearTime: 'Clear Time',
      deviceReportTime: 'Device Report Time',
      zone: 'Zone',
      loopNumber: 'Loop Number',
      channelNumber: 'Channel Number',
      controllerAddress: 'Controller Address',
      siteName: 'Site Name',
      region: 'Region',
      action: 'Action'
    }
  },
  // Operation Logs
  operationLogs: {
    placeholder: {
      search: 'Please enter the user name'
    },
    columns: {
      userName: 'User Name',
      companyName: 'Company Name',
      platform: 'Platform',
      baseProductType: 'User Type',
      logType: 'Log Type',
      content: 'Content',
      ip: 'IP',
      time: 'Time',
      action: 'Action'
    },
    platform: {
      spWeb: 'WEB',
      userWeb: 'User WEB',
      spApp: 'APP',
      userApp: 'User APP'
    },
    baseProductType: {
      5: 'User',
      101: 'Installer',
    },
    detail: {
      title: 'Operation Log Detail',
      basicInfo: 'Basic Information',
      changeInfo: 'Change Information',
      changeField: 'Changed Field',
      oldValue: 'Old Value',
      newValue: 'New Value'
    },
    category: {
      1: 'Site Management',
      2: 'Device Management',
      3: 'Region Management',
      4: 'Device Linkage',
      5: 'Device Mapping',
      6: 'Service Management',
      101: 'Add Site',
      102: 'Edit Site',
      201: 'Add Device',
      202: 'Edit Device',
      203: 'Delete Device',
      204: 'Device Migration',
      301: 'Add Region',
      302: 'Delete Region',
      303: 'Edit Region',
      401: 'Add Linkage Rule',
      402: 'Edit Linkage Rule',
      403: 'Delete Linkage Rule',
      501: 'Add Device Mapping',
      502: 'Edit Device Mapping',
      503: 'Delete Device Mapping',
      601: 'Site Delivery',
      602: 'Site Delivery and Apply for Trusteeship',
      603: 'Cancel Application',
      604: 'Trusteeship Renewal',
      605: 'Apply for Permission',
      606: 'Cancel Trusteeship',
      607: 'Initiate Trusteeship',
      608: 'Trusteeship Approval',
    }
  },
  company: {
    empty: 'No Unit',
    emptyTip: 'You have not configured unit information yet. Please click the button below to configure',
    name: 'Unit Name',
    creditCode: 'Unified Social Credit Code',
    division: 'Administrative Division',
    address: 'Detailed Address',
    editCompany: 'Unit Information',
    admin: {
      title: 'Administrator Info',
      email: 'Admin Email',
      phone: 'Admin Phone',
      realName: 'Admin Real Name'
    }
  },
  plans: {
    noDatatip1: 'The current area has no floor plan configured',
    noDataTip2: 'No drawings are available for this floor. Please proceed to the "Resource Upload" module to add them'
  }
}
